/* Small Pleasures · About us — "Turn the key": the saved pins scatter across tabs and gather into one box. */
(function () {
  var WIDE = '(min-width:1288px)';
  var SCAT_W = [[-610, 46, -8], [-410, 280, 6], [-590, 480, 4], [-230, 40, -5], [-170, 430, 9], [40, 120, -3], [130, 470, -10], [300, 30, 7], [460, 250, -6], [290, 330, 11]];
  var SCAT_N = [[-170, 22, -8], [-60, 64, 6], [72, 14, -5], [-150, 196, 7], [6, 176, -10], [92, 262, 5], [-122, 384, -4], [20, 404, 9]];

  function init(root) {
    if (!root || root.getAttribute('data-spc-ready')) return;
    root.setAttribute('data-spc-ready', '1');
    var stage = root.querySelector('[data-spc-stage]');
    if (!stage) return;
    var pins = [].slice.call(stage.querySelectorAll('[data-spc-pin]'));
    var btns = [].slice.call(root.querySelectorAll('[data-spc-toggle]'));
    var title = root.querySelector('[data-spc-title]');
    var line = root.querySelector('[data-spc-line]');
    var mq = window.matchMedia ? window.matchMedia(WIDE) : { matches: false };
    var gathered = false;

    function layout() {
      var wide = mq.matches, max = wide ? pins.length : Math.min(8, pins.length);
      pins.forEach(function (p, i) {
        if (i >= max) { p.hidden = true; return; }
        p.hidden = false;
        var x, y, r;
        if (gathered) {
          var cols = wide ? 5 : 4;
          var c = i % cols, row = Math.floor(i / cols);
          x = wide ? (-426 + 28 + c * 162) : (-164 + c * 84);
          y = wide ? (123 + 56 + row * 202) : (174 + row * 104);
          r = 0;
        } else {
          var s = (wide ? SCAT_W : SCAT_N)[i % (wide ? SCAT_W.length : SCAT_N.length)];
          x = s[0]; y = s[1]; r = s[2];
        }
        p.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + r + 'deg)';
        var t = p.querySelector('[data-spc-tab]');
        if (t) t.textContent = wide ? 'Tab ' + (i + 1) + ' of ' + max : 'Tab ' + (i + 1);
      });
    }
    function words() {
      var wide = mq.matches;
      if (title) title.textContent = gathered ? title.getAttribute('data-done') : title.getAttribute(wide ? 'data-open-w' : 'data-open-n');
      if (line) line.textContent = gathered ? line.getAttribute('data-done') : line.getAttribute('data-open');
      btns.forEach(function (b) {
        b.setAttribute('aria-pressed', gathered ? 'true' : 'false');
        var l = b.querySelector('[data-spc-label]');
        if (l) l.textContent = gathered ? b.getAttribute('data-done') : b.getAttribute('data-open');
      });
      stage.classList.toggle('is-gathered', gathered);
    }
    function toggle() { gathered = !gathered; words(); layout(); }
    btns.forEach(function (b) { b.addEventListener('click', toggle); });
    function onMq() { words(); layout(); }
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    words(); layout();
    requestAnimationFrame(function () { requestAnimationFrame(function () { stage.classList.add('is-ready'); }); });
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-spc-about]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
